import { combineReducers } from 'redux';
// Import reducers
import table from './vod_availability_table_reducer';
import form from './vod_availability_form_reducer';

export default combineReducers({
	table,
	form
});
